import React from 'react'
import { Icon } from '../ui/icon'

export interface BreadcrumbItem {
	name: string
	href: string
	current?: boolean
	ellipsis?: boolean
}

export interface BreadcrumbProps {
	items: BreadcrumbItem[]
}

/**
 * Generic Breadcrumb component for navigation.
 */
export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
	return (
		<nav className="flex" aria-label="Breadcrumb">
			<ol className="flex items-center space-x-2">
				{items?.map((item, index) => (
					<li key={item.name}>
						<div className="flex items-center whitespace-nowrap">
							{index !== 0 && (
								<Icon
									name="chevron-right"
									size="sm"
									className="mr-1 h-4 w-4 text-gray-400"
								/>
							)}
							{item.ellipsis ? (
								<span className="mx-1 text-sm text-gray-500">...</span>
							) : item.current ? (
								<span
									className="line-clamp-1 bg-amber-100 px-2 text-sm font-medium text-amber-700"
									aria-current="page"
								>
									{item.name.slice(0, 40) +
										(item.name.length > 40 ? '...' : '')}
								</span>
							) : (
								<a
									href={item.href}
									className="line-clamp-1 text-sm font-medium text-gray-500 hover:font-bold hover:text-amber-700"
								>
									{item.name.slice(0, 40) +
										(item.name.length > 40 ? '...' : '')}
								</a>
							)}
						</div>
					</li>
				))}
			</ol>
		</nav>
	)
}

export default Breadcrumb
